'use client'
import { useContext } from 'react'

import { priceToFixed } from '@doist/currency-notations'
import { Box, Text } from '@doist/marketist'

import { useTranslation } from 'app/i18n/client'
import { useLocale } from 'next-intl'
import { type Teams } from 'types/pricing'

import css from './pricing-info.module.css'

import { PricingContext } from '@/app/services/providers/contexts/pricing-context'

type Props = { plan: Teams.PricingPlan }

export function PricingInfo({ plan }: Props) {
    const locale = useLocale()
    const { t } = useTranslation(locale, 'pricing_v2_3')

    const { model, currency, billingCycle } = useContext(PricingContext)
    const pricing = model[currency]

    const isFree = plan === 'beginner'

    const priceMonthly = isFree ? 0 : pricing[plan]['monthly']
    const priceYearly = isFree ? 0 : pricing[plan]['yearly']
    const priceYearlyPerMonth = isFree ? 0 : pricing[plan]['yearlyPerMonth']

    const pricePerMonth: Record<Teams.BillingCycle, string> = {
        monthly: priceToFixed(priceMonthly),
        yearly: priceToFixed(priceYearlyPerMonth),
    }

    return (
        <Box className={css.pricingInfo} tag="p">
            <Box tag="span" className={css.priceGroup}>
                <Text size="body-2xs" className={css.currency} tag="span">
                    {pricing.shortName}
                </Text>
                <Text size="body-lg" className={css.price} tag="span">
                    {t('billing.currencyPrice', {
                        currency: pricing.shortSymbol,
                        price: pricePerMonth[billingCycle],
                    })}
                </Text>
            </Box>
            {!isFree ? (
                <Text size="body-2xs" tag="span" className={css.details}>
                    {t('billing.perUser')}
                    <br />
                    {billingCycle === 'yearly'
                        ? t('billing.currencyPrice', {
                              currency: pricing.shortSymbol,
                              price: priceYearly,
                          }) +
                          ' ' +
                          t('billing.billedYearly')
                        : t('billing.billedMonthly')}
                </Text>
            ) : null}
        </Box>
    )
}
